import { type MaybeRef, ref, onMounted} from "vue";
import { setSecureCookie } from "@/helpers/cookies";

export function useActiveCampaign({
    track = true
} : {
    track?: MaybeRef<boolean> 
} = { track: true })
{
    // Set to false if opt-in required
    var trackConversionByDefault = ref(track);

    function acEnableConversionTracking(value) {
        var expiration = new Date(new Date().getTime() + 1000 * 60 * 60 * 24 * 30);
        setSecureCookie("ac_enable_tracking", "1", { expires: expiration });
        acTrackConversion(value);
    }
    function acTrackConversion(value) {
        var trackcmp_email = '';
        var trackcmp_conversion = '%CONVERSION_ID%';
        var trackcmp_conversion_value = value;
        var trackcmp = document.createElement("script");
        trackcmp.async = true;
        trackcmp.src = 'https://trackcmp.net/convert?actid=1000206218&e='+encodeURIComponent(trackcmp_email)+'&c='+trackcmp_conversion+'&v='+trackcmp_conversion_value+
                        '&r='+encodeURIComponent(document.referrer)+'&u='+encodeURIComponent(window.location.href);
        var trackcmp_s = document.getElementsByTagName("script");
        if (trackcmp_s.length) {
            trackcmp_s[0].parentNode.appendChild(trackcmp);
        } else {
            var trackcmp_h = document.getElementsByTagName("head");
            trackcmp_h.length && trackcmp_h[0].appendChild(trackcmp);
        }
    }

    function trackConversion(value){
        if (trackConversionByDefault.value) {
            acEnableConversionTracking(value);
        }
    }

    return { 
        trackConversion,
    }
}